import { Feature } from "geojson";
import { MathAux } from "../math-aux/math-aux";
import { TimespanService } from "../timespan/timespan.service";

export class CSVAux {
    static exportObjectArrToCsv(filename: string, rows: any[]) {
      if (!rows || !rows.length) {
        return;
      }
      const separator = ';';
      const keys = Object.keys(rows[0]);
      const csvContent =
        keys.join(separator) +
        '\n' +
        rows.map(row => {
          return keys.map(k => {
            let cell = row[k] === null || row[k] === undefined ? '' : row[k];
            cell = cell instanceof Date
              ? cell.toLocaleString()
              : cell.toString().replace(/"/g, '""');
            if (cell.search(/("|,|\n)/g) >= 0) {
              cell = `"${cell}"`;
            }
            return cell;
          }).join(separator);
        }).join('\n');
  
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    static exportArrToCsv(filename: string, rows: any[]){
      const csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(rows.map(val=>val.join(";").replace(/(\r\n|\n|\r)/gm, " ")).join("\n"));
        let link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", filename);
        document.body.appendChild(link); 
        link.click();
        document.body.removeChild(link); 
    }

    static createCSVtableFromProperties(headers:{name: string, text: string}[],features:Feature<any>[],header:string,filename:string){
        let resultArray: any[] = []
        let localHeader = [header]
        headers.forEach(val=>{
            localHeader.push(val.text)
        })
        resultArray.push(localHeader)
        features.forEach( val=>{
            let line:any[] = []
            line.push(val.properties.nome_estacao_original)
            headers.forEach( header =>{
                if(header.name == "percent")line.push((MathAux.round(val.properties[header.name],1)+"%").replace(".",","))
                else if (header.name == "total" || header.name == "nfraca" || header.name == "nmoderada"
                || header.name == "nforte" || header.name == "nmuitoforte") line.push(TimespanService.secondsToFormattedText(val.properties[header.name]))
                else line.push(MathAux.round(val.properties[header.name],1).toString().replace(".",","))
            })
            resultArray.push(line)
        })
        
        let csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(resultArray.map(val => val.join(";")).join("\n").replace(".",","));
        let link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", filename);
        document.body.appendChild(link); 
        link.click();
        document.body.removeChild(link); 
    }



}